import React from "react";
import {
    View,
    Text,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Width from "../../../assets/Width";
import {globalConfigurableData, globalConst, GlobalScreens} from "../../../utils/globalConstant";
import { Button } from "../../../components/core/Button";
import {isMobile} from "../../../utils/commonMethods";

const PartnerWalletModal = ({ onBtnClick, conversionMessage }) => {


    return (
                <View style={{ alignItems: 'center', padding: 16}}>
                    <Text
                        style={{
                            ...globalFontStyle.appBlueHead,
                            color: globalConfigurableData.primaryTextColor1, paddingHorizontal: 50, textAlign: 'center'}}>
                        {GlobalScreens.Wallet?.partnerPopUpMessage}
                    </Text>
                    <View style={{ marginVertical: 35, padding: 15, borderRadius: 5, backgroundColor: GlobalScreens.Wallet.walletSummaryBtnColor}}>
                        <Text
                            style={{
                                ...globalFontStyle.appFontBody,
                                color: globalConfigurableData.secondaryTextColor1}}>
                            {conversionMessage}
                        </Text>
                    </View>
                    {isMobile() && (<Button
                        variant="black"
                        onPress={onBtnClick}
                        style={{
                            width: Width.width-32,
                        }}
                    >
                        Okay
                    </Button>)}
                </View>
    );
};

export default PartnerWalletModal;
